/** The token from an emailed link's address: "#t=<token>" (32 random bytes, base64url). */
export function tokenFromHash(hash: string): string | null {
  const token = new URLSearchParams(hash.replace(/^#/, '')).get('t');
  return token && /^[\w-]{20,100}$/.test(token) ? token : null;
}
